module.exports = "/_next/static/images/66199266815ffe4617c4ecb18b432b3d-tencent.png";